<template>
  <div class="card-form">
    <PageTable
      :loading="loading"
      :tableData="tableData"
      :tableHeight="tableHeight"
      :tablePage="page"
      :multiple="multiple"
      :reserve="reserve"
      :highlight="highlight"
      @reload="reload"
      @choose-change="(e) => $emit('choose-change', e)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageTable>
  </div>
</template>
<script>
import PageHeader from './header.vue'
import PageTable from './table.vue'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { PageTable, PageHeader },
  props: {
    multiple: { type: Boolean, default: false },
    reserve: { type: Boolean, default: false },
    highlight: { type: Boolean, default: true },
    tableHeight: { type: Number, default: 800 },
  },
  data() {
    return { usePage: true }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .purchaseMaterialDetailChooseListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
